const HEADEROFFSET = 48  // pixel

const scroll_to_anchor = function(hash){
  var offsetPosition = 0
  if (hash){
    var element = document.getElementById(decodeURI(hash).slice(1)) 
                  || document.getElementsByName(decodeURI(hash).slice(1))[0]
                  // slice: remove hash sign
    if (element){
      var elementPosition = element.getBoundingClientRect().top
      offsetPosition = elementPosition + window.pageYOffset - HEADEROFFSET
    }
  }
  window.scrollTo({top: offsetPosition})
}

const content_clicked = function(e){
  if (e.target.hash && e.target.href == e.target.origin + this.$route.path + e.target.hash){
    // has hash in url, same page
    e.preventDefault()
    scroll_to_anchor(e.target.hash)
  }
}

export default{
  content_clicked,
  scroll_to_anchor,
  HEADEROFFSET
}